import { action, computed, observable, runInAction } from "mobx";
import { api, apiOperacao } from "../../api";
import { IIuguPagamento, IUsuario } from "../../model";
import { toast } from "react-toastify";
import { sortBy, toast_error } from "../../utils";
import { AppStore } from "../AppStore";

export class _PerfilStore {
  obs = observable({
    pagamentos: [] as IIuguPagamento[],
    usuarios: [] as IUsuario[],
    working: false as boolean,
    currentPage: 1 as number,
    filter: "" as string,
    usuario_edit: null as IUsuario,
    countAssinatura1: 0 as number,
    countAssinatura2: 0 as number,
    countAssinatura3: 0 as number,
    countAssinatura4: 0 as number,
    countAssinatura5: 0 as number,
    totalPlano: 0 as number,
    metodo_pagamento: "" as string,
    plan_nome_completo: "" as string,
    plan_email: "" as string,
    plan_telefone: "" as string,
    plan_nome_cartao: "" as string,
    plan_cpf: "" as string,
    plan_numero_cartao: "" as string,
    plan_cvv: "" as string,
    plan_mes_cartao: "" as string,
    plan_ano_cartao: "" as string,
    empresas_planos: [] as any,
    empresas_planos_personalizados: [] as any,
    nome: "" as string,
    cnpj: "" as string,
    rua: "" as string,
    numero: "" as string,
    bairro: "" as string,
    cidade: "" as string,
    estado: "" as string,
    cep: "" as string,
    ddd: "" as string,
    telefone: "" as string,
    nome_pessoa: "" as string,
    cpf_pessoa: "" as string,
    rua_pessoa: "" as string,
    numero_pessoa: "" as string,
    bairro_pessoa: "" as string,
    cidade_pessoa: "" as string,
    cep_pessoa: "" as string,
    estado_pessoa: "" as string,
    valortotal_assinatura: 0 as number,
    expiraem_assinatura: "" as string,
    boletos_pendentes: [],
    email_assinatura: "" as string,
    alteracaoPlanos: [] as any[],
    historico_plano: [] as any,
    historico_faturas: [] as any,
    update_plano: false as boolean,
    contrato_assinado: true as boolean,
    contaEdit: false as boolean,
    change_tab_conta: "conta" as string,
    loading_alterPlano: false as boolean,
    mascara_contabil: "" as string,
    mascara_relatorios: "" as string,
    imagem: "" as string,
    users_dominio: [] as any,
    password_dominio: "" as string,
    user_dominio: "" as string,
    open_user_dominio: false as boolean,
    user_folha: "" as any,
    password_folha: "" as string,
    expires_at: null as Date,
    formPlan: false as boolean,
    dec_sefa_conta_message: false as boolean,
    dec_sefa_conta_numero: [] as string[],
    client_secret: "" as string,
    client_id: "" as string,
    troca_plano_notificacao: false as boolean,
    troca_plano_notificacao_numero: [] as string[]
  })

  @action
  setCurrentPage(page: number) {
    this.obs.currentPage = page;
  }

  @action
  setFilter(filter: string) {
    this.obs.filter = filter;
    this.obs.currentPage = 1;
  }

  @action
  setUser(usuario: IUsuario) {

    this.obs.usuario_edit = usuario;

  }

  // @action
  // async closeAlterPlanInfo(): Promise<void> {
  //   try {
  //     await api.get("/api/view-alter-plan-notificado");
  //   } catch (ex) {
  //     toast.error('Erro ao Plano Alterado Notificado, tente novamente mais tarde.', {});
  //   }
  // }

  @action
  async updateNextPlano(params: any) {
    try {

      let resp = await api.post("/api/upgrade_plano", params);

      if (resp.data.ok) {

        toast.success('Plano alterado', {});
        window.location.reload();

      } else {
        toast.error(resp.data.error, {});
      }

    } catch (ex) {
      toast.error('Erro ao alterar Plano, tente novamente mais tarde.', {});
    }
  }

  async load() {

    this.alteracoesPlanos()
    this.usuariosConta()
    this.assinaturaInfo()
    this.empresasCadastradas()
    this.dadosConta()
    this.getAssinatura();
    this.getTokenDecSefa()

  }

  async alteracoesPlanos() {

    try {

      let resp = await api.get("/api/historico-planos");

      this.obs.alteracaoPlanos = [];

      if(resp.status == 200) {
        this.obs.alteracaoPlanos = resp.data.historico
      }

    } catch (ex) {

      toast.error('Erro ao carregar Alteraçoes Planos, tente novamente mais tarde.', {});

    }

  }

  async usuariosConta() {

    try {

      let resp = await apiOperacao("user_permissions", { showErrorToast: false }).get("/user_permissions/usuarios-conta");

      this.obs.usuarios = [];

      if(resp.status == 200) {

        this.obs.usuarios = resp.data

      }

    } catch (ex) {}

  }

  async assinaturaInfo() {

    try {

      let resp_assi = await api.post("/api/assinaturas/info");

      runInAction(() => {
        this.obs.countAssinatura1 = resp_assi.data.contagem[0].count;
        this.obs.countAssinatura2 = resp_assi.data.contagem[1].count;
        this.obs.countAssinatura3 = resp_assi.data.contagem[2].count;
        this.obs.countAssinatura4 = resp_assi.data.contagem[3].count;
        this.obs.countAssinatura5 = resp_assi.data.contagem[4].count;
        this.obs.totalPlano = resp_assi.data.total;
      });

    } catch (ex) {

      toast.error('Erro ao consultar total Assiantura, tente novamente mais tarde.', {});
    }

  }

  async empresasCadastradas() {

    try {

      let resp_emp = await api.get("/api/count-empresas-plano");

      this.obs.empresas_planos = []
      this.obs.empresas_planos_personalizados = []

      resp_emp.data?.forEach((obj) => {

        if (obj.plano && obj.plano.default) {

          if (!this.obs.empresas_planos[`faixa${obj.plano.faixa}`]) {
            this.obs.empresas_planos[`faixa${obj.plano.faixa}`] = []
          }

          this.obs.empresas_planos[`faixa${obj.plano.faixa}`].push(obj);

        }

        if (obj.plano && !obj.plano.default && obj.plano.old_id == 4) {
          this.obs.empresas_planos_personalizados.push(obj)
        }

      });

    } catch (ex) {

      toast.error('Erro ao consultar total Empresas Planos, tente novamente mais tarde.', {});

    }

  }

  async dadosConta() {
    try {
      let resp_conta = await api.get("/api/dados-conta");

      runInAction(() => {
        this.obs.nome = resp_conta.data.nome;
        this.obs.cnpj = resp_conta.data.cnpj;
        this.obs.rua = resp_conta.data.rua;
        this.obs.numero = resp_conta.data.numero;
        this.obs.bairro = resp_conta.data.bairro;
        this.obs.cidade = resp_conta.data.cidade;
        this.obs.estado = resp_conta.data.estado;
        this.obs.cep = resp_conta.data.cep;
        this.obs.ddd = resp_conta.data.ddd;
        this.obs.telefone = resp_conta.data.telefone;

        this.obs.nome_pessoa = resp_conta.data.nome_pessoa;
        this.obs.cpf_pessoa = resp_conta.data.cpf_pessoa;
        this.obs.rua_pessoa = resp_conta.data.rua_pessoa;
        this.obs.numero_pessoa = resp_conta.data.numero_pessoa;
        this.obs.bairro_pessoa = resp_conta.data.bairro_pessoa;
        this.obs.cidade_pessoa = resp_conta.data.cidade_pessoa;
        this.obs.cep_pessoa = resp_conta.data.cep_pessoa;
        this.obs.estado_pessoa = resp_conta.data.estado_pessoa;
        this.obs.mascara_contabil = resp_conta.data.mascara_contabil;
        this.obs.mascara_relatorios = resp_conta.data.mascara_relatorios;
        this.obs.imagem = resp_conta.data.imagem;
        this.obs.dec_sefa_conta_message = resp_conta.data.dec_sefa_conta_message;
        this.obs.dec_sefa_conta_numero = resp_conta.data.dec_sefa_conta_numero;

        this.obs.troca_plano_notificacao = resp_conta.data.troca_plano_notificacao;
        this.obs.troca_plano_notificacao_numero = resp_conta.data.troca_plano_notificacao_numero;

      });

    } catch (ex) {
      toast.error('Erro ao carregar Conta, tente novamente mais tarde.', {});
    }

  }

  async getAssinatura(): Promise<void> {
    try {
      this.obs.boletos_pendentes = [];
      // Status asssinatura
      let status_assinatura = await api.get("/api/status-assinatura");

      runInAction(() => {
        let total = undefined;
        this.obs.boletos_pendentes = [];

        if (status_assinatura.data.recent_invoices.length > 0) {
          this.obs.historico_faturas = status_assinatura.data.recent_invoices;

          this.obs.historico_plano =
            status_assinatura.data.recent_invoices[0].secure_url;

          status_assinatura.data.recent_invoices?.map(el => {
            if (el.status === "pending") {
              this.obs.boletos_pendentes.push({
                url: el.secure_url,
                vencimento: el.due_date.split("-").reverse().join("/"),
              });
            }
          });

          this.obs.email_assinatura = status_assinatura.data.customer_email;

          if (status_assinatura.data.subitems) {
            if (status_assinatura.data.subitems.length > 0) {
              total = 0;

              status_assinatura.data.subitems?.map(element => {
                total += element.price_cents / 100;
              });
            }
          }

          this.obs.valortotal_assinatura = total;
          this.obs.expiraem_assinatura = status_assinatura.data.expires_at;
        }
      });
    } catch (ex) { }
  }

  async alterPlan(): Promise<void> {
    let params = {}
    this.obs.loading_alterPlano = true

    if (PerfilStore.obs.metodo_pagamento == "bank_slip") {
      params = {
        boleto: true,
        cartao: false,
      };
    }

    if (PerfilStore.obs.metodo_pagamento == "credit_card") {
      params = {
        boleto: false,
        cartao: true,
      };
    }

    if (Object.keys(params).length === 0) {
      toast.error(`Selecione uma forma de pagamento!`, {});
      this.obs.loading_alterPlano = false
      return
    }

    try {

      let resp = await apiOperacao("faturas").post("/faturas/alter-plan", params);

      if (resp.data.ok) {

        toast.success('Método de pagamento alterado com sucesso!', {});

        this.obs.formPlan = false

        await AppStore.loadUsuario()

      } else {

        toast.error('Erro ao alterar forma de pagamento.', {});

      }

    } catch (ex) {

      toast.error(`Erro ao alterar forma de pagamento, tente novamente mais tarde.`, {});

    }

    this.obs.loading_alterPlano = false

  }

  async alterar_conta(): Promise<void> {
    let params = {
      nome: PerfilStore.obs.nome,
      cnpj: PerfilStore.obs.cnpj,
      rua: PerfilStore.obs.rua,
      numero: PerfilStore.obs.numero,
      bairro: PerfilStore.obs.bairro,
      cidade: PerfilStore.obs.cidade,
      estado: PerfilStore.obs.estado,
      cep: PerfilStore.obs.cep,
      ddd: PerfilStore.obs.ddd,
      telefone: PerfilStore.obs.telefone,

      nome_pessoa: PerfilStore.obs.nome_pessoa,
      cpf_pessoa: PerfilStore.obs.cpf_pessoa,
      rua_pessoa: PerfilStore.obs.rua_pessoa,
      numero_pessoa: PerfilStore.obs.numero_pessoa,
      bairro_pessoa: PerfilStore.obs.bairro_pessoa,
      cidade_pessoa: PerfilStore.obs.cidade_pessoa,
      cep_pessoa: PerfilStore.obs.cep_pessoa,
      estado_pessoa: PerfilStore.obs.estado_pessoa,
      mascara_contabil: PerfilStore.obs.mascara_contabil,
      mascara_relatorios: PerfilStore.obs.mascara_relatorios,
      dec_sefa_conta_message: PerfilStore.obs.dec_sefa_conta_message,
      dec_sefa_conta_numero: PerfilStore.obs.dec_sefa_conta_numero,
      troca_plano_notificacao: PerfilStore.obs.troca_plano_notificacao,
      troca_plano_notificacao_numero: PerfilStore.obs.troca_plano_notificacao_numero
    };

    let config = {};

    try {
      let resp = await apiOperacao("conta").put("/conta/alter-conta", params, config);

        if (resp.data == "ok") {
          toast.success('Dados da conta alterados com sucesso!', {});
        } else {
          toast.error('Erro ao alterar os dados. Verifique todos os campos.', {});
        }
      } catch (ex) {
      toast.error(`Erro ao atualizar dados da Conta, tente novamente mais tarde.`, {});
    }
  }

  @action
  refresh() {
    window.location.reload();
  }

  @action
  setWorking(working: boolean) {
    this.obs.working = working;
  }

  get(id: number): IIuguPagamento {
    return this.obs.pagamentos.find(x => x.id == id);
  }

  @computed
  get sortedPagamentos(): IIuguPagamento[] {
    return sortBy(this.obs.pagamentos, "id");
  }

  @computed
  get forDisplay(): IIuguPagamento[] {
    let pagamentos = this.obs.pagamentos;
    return sortBy(pagamentos, "id");
  }

  doSaveFileContador = (certificado: string, senha: string) => {
    try {
      var data = new FormData();
      data.append("file", certificado[0]);

      fetch(`/api/upload-certificado-contabilidade?senha=${senha}`, {
        method: "POST",
        body: data,
        headers: { "authorization": `Bearer ${localStorage.getItem('x-nz-token-api') ?? ""}` },
      })
        .then(response => response.json())
        .then(response => {
          if (response.error) {
            toast.error(response.error, {});
          } else {
            AppStore.loadUsuario()
          }
        })
    } catch (ex) {
      toast.error('Erro ao salvar Certificado Contador, tente novamente mais tarde.', {});
    }
  };

  async handleSaveUserDominio() {
    PerfilStore.obs.open_user_dominio = false

    let params = {
      user_dominio: PerfilStore.obs.user_dominio,
      password_dominio: PerfilStore.obs.password_dominio,
      user_folha: PerfilStore.obs.user_folha,
      password_folha: PerfilStore.obs.password_folha
    };

    try {
      let resp = await api.post("/api/conta/user-dominio", params);

      if (resp.data.ok) {
        toast.success('Usuário Domínio salvo com sucesso!', {});
        await this.handleUserDominio()
      } else {
        toast.error('Erro ao salvar Usuário Domínio', {});
      }
    } catch (ex) {
      toast.error(`Erro ao salvar Usuário Domínio, tente novamente mais tarde.`, {});
    }
  }

  async handleUserDominio() {

    try {
      let resp = await api.get("/api/conta/user-dominio");
      this.obs.users_dominio = []

      if (resp.data.ok) {
        if (resp.data.user.user_dominio != "" && resp.data.user.user_dominio) {
          this.obs.users_dominio = [{
            user_dominio: resp.data.user.user_dominio,
            password_dominio: resp.data.user.password_dominio,
            user_folha: resp.data.user.user_folha,
            password_folha: resp.data.user.password_folha,
            _id: resp.data.user._id
          }]
        }
      }
    } catch (ex) {
      toast.error(`Erro ao salvar Usuário Domínio, tente novamente mais tarde.`, {});
    }
  }

  handleSendAlterPass = async (id_user: string, newPassword: string) => {

    try {

      await api.post("/api/change-password-user", {
        id_user: id_user,
        new_password: newPassword,
      });

      toast.success('Senha alterada com sucesso', {});

    } catch (ex) {

      toast.error("Erro alterando a senha do Usuário, tente novamente mais tarde.", {});

    }

  };

  handleSendAlterEmailIugu = async (newEmail: string) => {

    try {

      await apiOperacao("faturas").post("/faturas/altera-email-assinatura", { email: newEmail });

      toast.success('E-mail alterado com sucesso', {});

      this.obs.email_assinatura = newEmail;

    } catch (ex) {

      toast.error("Erro ao alterar E-mail, tente novamente mais tarde.", {});

    }

  };

  /**
   * Salva as credenciais da API DEC Sefa.
   */
  async saveTokenDecSefa() {

    try {

      const data = {
        client_secret: this.obs.client_secret,
        client_id: this.obs.client_id
      }

      let resp = await apiOperacao("dec_sefa").post("/dec_sefa/api/config", data);

      if (resp.data.ok) {

        toast.success("Tokens salvos com sucesso!", {});

        await this.getTokenDecSefa()

      } else {

        toast.error(`${resp.data.msg}`, {});

      }

    } catch (ex) {

      toast_error(ex, `${ex?.response?.data?.msg || "Ocorreu um erro, tente novamente mais tarde!"}`);

    }

  }

  /**
   * Busca as credenciais da API DEC Sefa.
   */
  async getTokenDecSefa() {

    try {

      let resp = await apiOperacao("dec_sefa").get("/dec_sefa/token/index");

      this.obs.client_secret = ""
      this.obs.client_id = ""

      if (resp.data.ok && resp.data.token) {

        this.obs.client_secret = resp.data.token?.client_secret || ""
        this.obs.client_id = resp.data.token?.client_id || ""

      }

    } catch (ex) {

      toast_error(ex, `${ex?.response?.data?.msg || "Ocorreu um erro, tente novamente mais tarde!"}`);

    }

  }

  handleDeleteUsuario = async (id: any) => {

    try {

      let resp = await apiOperacao("user_permissions").get(`/user_permissions/deleta-usuario/${id}`);

      if (resp.data.ok) {

        toast.success('Usuário Deletado com sucesso', {});

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast_error(ex, `Erro ao deletar o Usuário, tente novamente mais tarde.`);

    } finally {

      setInterval(this.refresh, 1000);

    }

  };

}

export const PerfilStore = new _PerfilStore();
